import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useStoreStore } from '@/stores/store-store';
import { useFulfillment } from '@/hooks/use-fulfillment';
import OrdersTable from '@/components/tables/OrdersTable';
import RefundManagementModal from '@/pages/orders/components/RefundManagementModal';
import OrderDetailsModal from '@/pages/orders/components/OrderDetailsModal';
// import { useFilterStore } from '@/stores/filter-store';

export default function FulfillmentPage() {
  const [searchParams] = useSearchParams();
  const { currentStore } = useStoreStore();
  // const { setFulfillmentStatus, setFulfillmentSubStatus } = useFilterStore();

  // Get current tab from URL params (handled by LayoutWrapper)
  const selectedTab = searchParams.get('tab') || 'outstanding';
  const [isRefundOpen, setIsRefundOpen] = useState(false);
  const [selectedOrderCode, setSelectedOrderCode] = useState<string | undefined>(undefined);
  const [isDetailsOpen, setIsDetailsOpen] = useState(false);
  const [selectedDetailsOrderCode, setSelectedDetailsOrderCode] = useState<string | undefined>(undefined);

  // Use the fulfillment hook
  const { 
    orders,
    totalOrders,
    error,
    isLoading,
    refreshOrders,
    updateSorting,
    sortField,
    sortOrder
  } = useFulfillment({
    storeId: currentStore?.id,
    autoFetch: true
  });

  // const handleStatusSelect = (status: string) => {
  //   setFulfillmentStatus(status);
  // };

  // const handleSubStatusSelect = (subStatus: string) => {
  //   setFulfillmentSubStatus(subStatus);
  // };

  return (
    <div className="space-y-6">
      {/* Orders Table */}
      <OrdersTable 
        statusFilter={selectedTab} 
        storeId={currentStore?.id}
        fulfillmentData={{
          orders,
          totalOrders,
          error,
          isLoading,
          refreshOrders,
          updateSorting,
          sortField,
          sortOrder
        }}
        onViewAllClick={(order: any) => {
          const code =
            (order as any).code ||
            (order as any).reference ||
            (order as any).order?.reference ||
            undefined;
          setSelectedDetailsOrderCode(code);
          setIsDetailsOpen(true);
        }}
        onRefundClick={selectedTab === 'awaiting_resolution' ? ((order: any) => {
          const code =
            (order as any).code ||
            (order as any).reference ||
            (order as any).order?.reference ||
            undefined;
          setSelectedOrderCode(code);
          setIsRefundOpen(true);
        }) : undefined}
      />

      <RefundManagementModal
        isOpen={isRefundOpen}
        onClose={() => setIsRefundOpen(false)}
        orderCode={selectedOrderCode}
      />

      <OrderDetailsModal
        isOpen={isDetailsOpen}
        onClose={() => setIsDetailsOpen(false)}
        orderCode={selectedDetailsOrderCode}
      />
    </div>
  );
}
